/* eslint-disable react/jsx-props-no-spreading */
import React from "react";

import TransformAnimation from "@/app/shared-components/animation/transform-animation";
import BackToRenewal from "@/app/shared-components/back-to-renewal/back-to-renewal";
import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import Footer from "@/app/shared-components/footer";
import HelpOverlayButton from "@/app/shared-components/help-overlay-button/help-overlay-button-wizard";
import Loader from "@/app/shared-components/loader/loader";
import Logo from "@/app/shared-components/logo-component/logo";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import { RenewalPage } from "@/config/app-constant";
import { APPLICATION } from "@/constants";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";

import Styles from "./form-section.layout.module.css";
import { FormSectionLayoutType } from "../../types/question-layout-types";

function FormSectionLayout(props: Readonly<FormSectionLayoutType>) {
  const {
    backToRenewalsText,
    content,
    editPage,
    formAnimationRef,
    footer,
    footerAnimationRef,
    isLoading = false,
    footerRef,
    setIsOpenUnsavedChangesModal,
    setIsCancelEditModalOpen,
  } = props;

  const { t } = useWizardTranslation();
  const { current } = useWizard();

  const isHideCancelEditButton = false;

  return (
    <div className=" flex flex-col h-full">
      <div
        className={` text-surface-neutral-option-2 rounded-radius-xxl relative`}
      >
        <HelpOverlayButton />
        <Logo color="primary" heightClass="h-[80px]" size="xl" />
      </div>
      <div className="lg:flex block lg:flex-col lg:h-full justify-between lg:items-center md:py-spacing-xxl py-spacing-m px-spacing-m">
        <TransformAnimation
          animationRef={formAnimationRef}
          currentPage="usagePage"
        >
          <div className="h-full">
            {isLoading ? (
              <div className="w-full flex justify-center items-center h-full">
                <Loader />
              </div>
            ) : (
              <>
                <div className="w-full flex justify-center">
                  <div className="lg:w-[450px] md:w-[400px] w-full ">
                    {APPLICATION === RenewalPage && editPage && (
                      <div>
                        <BackToRenewal
                          label={backToRenewalsText ?? "Back to renewal"}
                          className="pb-spacing-m md:pb-[0px] 
        top-[-2px] !px-[0px] mb-spacing-l md:!mb-spacing-l lg:mx-[0px]"
                          onClick={() => setIsOpenUnsavedChangesModal(true)}
                        />
                      </div>
                    )}
                    {APPLICATION !== RenewalPage &&
                      editPage &&
                      !isHideCancelEditButton && (
                        <div>
                          <ButtonWrapper
                            hierarchy="tertiary"
                            label={t("cancel_editing", "Cancel editing")}
                            id="cancel-edit"
                            className={`${Styles.cancelEditButton}`}
                            isRightIcon={false}
                            onClick={() => setIsCancelEditModalOpen(true)}
                          />
                        </div>
                      )}
                  </div>
                </div>
                {content}
              </>
            )}
          </div>
        </TransformAnimation>

        <Footer
          {...footer}
          footerAnimationRef={footerAnimationRef}
          footerRef={footerRef}
        />
      </div>
    </div>
  );
}

export default FormSectionLayout;
